import postHttp from './../../plugin/extendFn/postHttp'
import loginService from './../../plugin/extendFn/loginService'


async function KeepAliveGard(to, from, next) {
    console.log("gard >>> KeepAliveGard ----------------------------------------");
    console.log('-------- gard >>  keepAlive ---------')
    console.log(from)

    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '';
    }

    if (to.name == 'Live') {
        if (from.name == 'Details' || from.name == 'Testlist') {
            to.meta.keepAliveChange = false
        } else {
            to.meta.keepAliveChange = true
        }

    }
    if (to.name == 'Video') {
        if (from.name == 'vDetails' || from.name == 'Allvideo') {
            to.meta.keepAliveChange = false
        } else {
            to.meta.keepAliveChange = true
        }

    }

    if (to.name == 'Allvideo') {
        to.meta.keepAliveChange = from.name != 'vDetails';
    }

    if (to.name != 'vDetails' && from.name == 'Allvideo') {
        from.meta.keepAliveChange = true;
    }

    if (to.name == 'Testlist') {
        to.meta.keepAliveChange = from.name != 'Details';
    }

    if (to.name == 'myBuy') {
        if (from.name == 'vDetails' || from.name == 'Details' || from.name == 'colDetails') {
            to.meta.keepAliveChange = false
        } else {
            to.meta.keepAliveChange = true
        }

    }
    if (to.name == 'Collection') {
        if (from.name == 'vDetails' || from.name == 'Details' || from.name == 'colDetails') {
            to.meta.keepAliveChange = false
        } else {
            to.meta.keepAliveChange = true
        }

    }
    next()
}

export default KeepAliveGard


// WEBPACK FOOTER //
// ./src/router/gard/KeepAliveGard.js